import { render, staticRenderFns } from "./FarmerList.vue?vue&type=template&id=24a94b34"
import script from "./FarmerList.vue?vue&type=script&lang=js"
export * from "./FarmerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports